export default __webpack_public_path__ + "static/dtaylor-de890988e9d2dfdd34fd2714a02251b7.jpg";